import LockedTournamentLanding from '@app/components/tournament/LockedTournamentLanding'
import { RootState, useAppDispatch } from '@app/store'
import { getPasswordVerificationCheck, getPasswordVerificationLogin } from '@app/store/passwordVerification/actions'
import { decodeString, getLocalStorageItem, TOURNAMENT_STORAGE_KEY_PREFIX } from '@app/utils/storage'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'
import { PageNotFound } from '../page-not-found/PageNotFound'
import { ErrorPayload } from '@app/store/passwordVerification/sagas'
import OverlayLoader from '@app/components/ui/OverlayLoader'

const ProtectedTournamentGuard = () => {
  const dispatch = useAppDispatch()
  const tournamentId = Number(useParams().tournamentId) ?? ''
  const passwordVerificationState = useSelector((state: RootState) => state.passwordVerificationReducer)
  useEffect(() => {
    if (typeof tournamentId === 'number' && !isNaN(tournamentId)) {
      dispatch(getPasswordVerificationCheck(tournamentId))
    }
  }, [])

  useEffect(() => {
    const item: string | null = getLocalStorageItem(`${TOURNAMENT_STORAGE_KEY_PREFIX}${tournamentId}`)

    const parsed = item ? JSON.parse(decodeString(item)) : null
    if (
      !passwordVerificationState.isLoading &&
      typeof tournamentId === 'number' &&
      !isNaN(tournamentId) &&
      passwordVerificationState.passwordVerification === true &&
      !passwordVerificationState.isUserVerified &&
      parsed?.password
    ) {
      dispatch(getPasswordVerificationLogin(tournamentId, parsed.password))
    }
  }, [
    tournamentId,
    passwordVerificationState.isLoading,
    passwordVerificationState.passwordVerification,
    passwordVerificationState.isUserVerified,
  ])

  if (!passwordVerificationState.isLoading && passwordVerificationState.error === ErrorPayload.PAGE_NOT_FOUND) {
    return <PageNotFound />
  }

  if (!passwordVerificationState.isLoading && passwordVerificationState.passwordVerification === false) {
    return <Outlet />
  }

  // If we have verified the password and it's correct, render the tournament site
  if (!passwordVerificationState.isLoading && passwordVerificationState.isUserVerified === true) {
    return <Outlet />
  }

  if (passwordVerificationState.isLoading || passwordVerificationState.passwordVerification === null) {
    return <OverlayLoader />
  }

  // If we have verified the password and it's incorrect, show the locked tournament landing page
  return <LockedTournamentLanding />
}

export default ProtectedTournamentGuard
